<div class="npdc-title">
  <hgroup>
    <h1>{{ case().title }}</h1>
    <p>Case {{ case().number || 'N/A' }}, {{ case().area || 'N/A' }}, {{ case().date | date }}</p>
  </hgroup>
  <div class="npdc-title__actions">
    @if (authService.canInvoke(authService.endpoints.editCase)) {
      <a mat-flat-button routerLink="edit">Edit</a>
    }
    @if (authService.canInvoke(authService.endpoints.deleteCase)) {
      <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    }
  </div>
</div>

@if (case().description) {
  <h2>Description</h2>
  <p style="white-space: pre-line" [innerHtml]="case().description | link: '/placename?q='"></p>
}

@if (case().comment) {
  <h2>Comment</h2>
  <p style="white-space: pre-line">
    {{ case().comment }}
  </p>
}

<h2>Placenames</h2>
<app-list [resource]="placenames" [disableClear]="true">
  @if (!placenames.error()) {
    <mat-nav-list>
      @for (p of placenames.value()?.items; track p.id) {
        <a mat-list-item routerLink="/placename/{{ p.id }}">
          <mat-icon matListItemIcon>location_on</mat-icon>
          <span matListItemTitle>{{ p.title }}</span>
          <span matListItemLine>{{ p.area || 'N/A' }}, {{ p.start }}</span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="page.set($event.pageIndex)"
      [length]="placenames.value()?.count"
      [pageIndex]="page()"
      [pageSize]="10"
      [hidePageSize]="true"
    >
    </mat-paginator>
  }
</app-list>

<h2>Other</h2>
<mat-list>
  <mat-list-item>
    <div matListItemTitle>Created</div>
    <span matListItemLine
      >{{ case().created | date }} by
      @if (case().createdBy | resolveUser | async; as user) {
        <a href="mailto:{{ user.email }}">{{ user.email }}</a>
      } @else {
        {{ case().createdBy }}
      }
    </span>
  </mat-list-item>
  <mat-list-item>
    <div matListItemTitle>Modified</div>
    <span matListItemLine
      >{{ case().modified | date }} by
      @if (case().modifiedBy | resolveUser | async; as user) {
        <a href="mailto:{{ user.email }}">{{ user.email }}</a>
      } @else {
        {{ case().modifiedBy }}
      }
    </span>
  </mat-list-item>
</mat-list>

<mat-menu #optionsMenu>
  <button mat-menu-item (click)="delete()">Delete</button>
</mat-menu>
